<span class="badge badge--default badge--small {{ class }}" title="{{ env }}">{{
  env | slice: 0:truncateAt
}}</span>
